import { render } from "./DeliveryTabHistory.vue?vue&type=template&id=9d20969c"
import script from "./DeliveryTabHistory.vue?vue&type=script&lang=js"
export * from "./DeliveryTabHistory.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__